module.exports = __webpack_public_path__ + "img/achievement4.00bb29e3.jpg";